import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-circular-progress',
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg [attr.width]="size" [attr.height]="size" class="transform -rotate-90">
      <!-- Background circle -->
      <circle
        [attr.cx]="size / 2"
        [attr.cy]="size / 2"
        [attr.r]="radius"
        [attr.stroke]="backgroundColor"
        [attr.stroke-width]="strokeWidth"
        fill="none"
      />
      <!-- Progress circle -->
      <circle
        [attr.cx]="size / 2"
        [attr.cy]="size / 2"
        [attr.r]="radius"
        [attr.stroke]="color"
        [attr.stroke-width]="strokeWidth"
        [attr.stroke-dasharray]="circumference"
        [attr.stroke-dashoffset]="strokeDashoffset"
        fill="none"
        class="transition-all duration-300"
        stroke-linecap="round"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    :host {
      display: inline-block;
    }
  `]
})
export class CircularProgressComponent {
  @Input() size: number = 24;
  @Input() strokeWidth: number = 3;
  @Input() progress: number = 0; // 0-100
  @Input() color: string = '#ef4444';
  @Input() backgroundColor: string = 'rgba(239, 68, 68, 0.1)';

  get radius(): number {
    return (this.size - this.strokeWidth) / 2;
  }

  get circumference(): number {
    return 2 * Math.PI * this.radius;
  }

  get strokeDashoffset(): number {
    return this.circumference - (this.progress / 100) * this.circumference;
  }
}
